<template>
    <table class="table align-middle w-auto">
        <thead>
        <tr>
            <th scope="col" v-for="elem in thead">
                <div class="th-inner ">
                    {{elem}}
                </div>
            </th>
            <th scope="col" v-if="actions.length > 0">Действия</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="row, in tbody" v-on:click="oneClick(row)">
            <td v-for="elem, in row.tbody">
                {{elem}}
            </td>
            <td v-if="actions.length > 0" class="d-flex flex-row align-items-center">
                <template v-for="action in actions">
                    <template v-if="action.hasOwnProperty('svg')">
                        <div v-html="action.svg" v-on:click="actionClick(action.emit, row)" class="align-bottom"></div>
                    </template>
                    <a v-else class="btn btn-info m-1" ref="" v-on:click="actionClick(action.emit, row)">{{action.text}}</a>
                </template>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: "TableElement",
    props: {
        thead: Object,
        tbody: Object,
        actions: {
            type: [Array, Object],
            default: []
        }
    },
    data: function () {
        return {
            delay: 500,
            clicks: 0,
            timer: undefined
        }
    },
    emits: [
        "deleteItem",
        "viewItem",
        "editItem",
        "changeRights",
        "content",
        "group",
        "playlist"
    ],
    methods: {
        actionClick: function (emit, params) {
            if(emit == 'deleteItem') {
                let conf = confirm('Вы уверены что хотите удалить запись?');
                if(!conf) {
                    return;
                }
            }
            event.preventDefault();
            this.$emit(emit, params);
        },
        oneClick(params, event) {
            this.clicks++;
            if (this.clicks === 1) {
                this.timer = setTimeout( () => {
                    this.clicks = 0
                }, this.delay);
            } else {
                clearTimeout(this.timer);
                this.$emit('viewItem', params);
                this.clicks = 0;
            }
        }
    },
    mounted() {
        setTimeout(() => {
            let tdArray = document.querySelectorAll('td');
            console.log(tdArray);

            tdArray.forEach(td => {
                td.height = td.parentElement.getBoundingClientRect().height;
            });
        }, 150);
    }
}
</script>

<style scoped>

</style>
